export default __webpack_public_path__ + "static/media/rejected-22px.1f7991d4.svg";